<template>
 <div class="card-picture">
  <div class="image-container">
    <img :src="thumbnailUrl" alt="" @load="onImageLoad" @error="onImageError" v-show="!isLoading" />
    <div v-if="isLoading" class="skeleton-loader"></div>
  </div>
  <div class="bg-gradient-card"></div>
  <div class="text-card-picture">
   <p>Última Ministração</p>
   <div class="title">
    <h2>{{ title }}</h2>
    <i>{{ minister }}</i>
   </div>
   <div class="buttons-card-picture">
    <div class="btn-card" @click="handlePlay">
     <i class="fa fa-play"></i>
     <span>ASSISTIR</span>
    </div>
   </div>
  </div>
  <a :href="youtube_link" target="_blank" class="btn-card-mobile">
    <i class="fa fa-play"></i>
  </a>

  <!-- Modal -->
  <div v-if="showModal" class="video-modal-backdrop" @click="closeModal">
    <div class="video-modal" @click.stop>
      <button class="video-modal-close" @click="closeModal">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </button>
      <div class="video-modal-player">
        <iframe
          :src="embedUrl"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import { getYouTubeThumbnailFromUrl, extractYouTubeVideoId } from '@/utils/youtube.js'

export default {
 name: "CardPicture",
 props: {
    lastPreaching: {
        type: Object
    }
 },
 data() {
    return {
        title: '',
        minister: '',
        youtube_link: '',
        isLoading: true,
        currentThumbnailQuality: 'maxresdefault',
        showModal: false,
    }
 },
 computed: {
    thumbnailUrl() {
      return getYouTubeThumbnailFromUrl(this.youtube_link, this.currentThumbnailQuality)
    },
    isMobile() {
      return window.innerWidth <= 768
    },
    embedUrl() {
      const videoId = extractYouTubeVideoId(this.youtube_link)
      return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0` : ''
    }
  },
 methods: {
    onImageLoad() {
        this.isLoading = false
    },
    onImageError() {
        const qualities = ['maxresdefault', 'hqdefault', 'mqdefault', 'default']
        const currentIndex = qualities.indexOf(this.currentThumbnailQuality)
        if (currentIndex < qualities.length - 1) {
            this.currentThumbnailQuality = qualities[currentIndex + 1]
        } else {
            this.isLoading = false
        }
    },
    handlePlay() {
        if (this.isMobile) {
            window.open(this.youtube_link, '_blank')
        } else {
            this.showModal = true
            document.body.style.overflow = 'hidden'
        }
    },
    closeModal() {
        this.showModal = false
        document.body.style.overflow = 'auto'
    }
 },
 watch: {
    lastPreaching: {
        immediate: true,
        handler(val) {
            if (!val) return
            this.title = val.title
            this.minister = val.minister
            this.youtube_link = val.youtube_link
            this.isLoading = true
            this.currentThumbnailQuality = 'maxresdefault'
        }
    }
 },
 beforeUnmount() {
    document.body.style.overflow = 'auto'
 }
};
</script>

<style scoped>
.card-picture {
 width: 100%;
 max-width: 1080px;
 max-height: 608px;
 overflow: hidden;
 border-radius: 10px;
 position: relative;
}

.skeleton-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  z-index: 1;
}

@keyframes loading {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.bg-gradient-card {
 position: absolute;
 top: 0;
 width: 100%;
 height: 100%;
 background: linear-gradient(
  180deg,
  rgba(0, 0, 0, 0.15) 0%,
  rgba(0, 0, 0, 0.25) 40%,
  rgba(0, 0, 0, 0.85) 90%
 );
 z-index: 1;
}

.card-picture img {
 width: 100%;
 height: 100%;
 object-fit: cover;
 position: absolute;
 top: 0;
 left: 0;
}

.image-container {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}

.text-card-picture {
 position: absolute;
 bottom: 40px;
 left: 30px;
 color: #fff;
 text-align: left;
 display: flex;
 flex-direction: column;
 gap: 40px;
 z-index: 2;
}

.text-card-picture .title {
  margin-top: -40px;
}

.text-card-picture p {
 font-size: 16px;
 opacity: 0.8;
}

.text-card-picture h2 {
 font-size: 32px;
 margin: 0;
}

.text-card-picture .title {
 position: relative;
}

.text-card-picture .title i {
 opacity: 0.8;
 font-size: 14px;
 text-align: right;
 position: absolute;
 right: 0;
}

.text-card-picture a {
  text-decoration: none;
  color: #fff;
}

.btn-card {
 display: flex;
 align-items: center;
 gap: 10px;
 background: #db0d0d;
 border-radius: 8px;
 width: fit-content;
 padding: 12px 28px;
 font-size: 15px;
 font-weight: 600;
 cursor: pointer;
 transition: opacity 0.2s ease;
 letter-spacing: 1px;
}

.btn-card:hover {
 opacity: 0.85;
}

.btn-card .fa {
 font-size: 14px;
}

.btn-card-mobile {
  display: none;
  text-decoration: none;
  color: #fff;
}

/* Modal */
.video-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-modal {
  width: 90%;
  max-width: 900px;
  position: relative;
}

.video-modal-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.video-modal-close:hover {
  opacity: 1;
}

.video-modal-player {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  border-radius: 8px;
  overflow: hidden;
}

.video-modal-player iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 768px) {
  .buttons-card-picture .btn-card {
    display: none;
  }
  .btn-card-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 2;
    background: #db0d0d;
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }
  .btn-card-mobile .fa {
    font-size: 16px;
    margin-left: 2px;
  }
}

@media screen and (max-width: 496px) {
 .text-card-picture {
  gap: 0px;
  bottom: 30px;
  left: 15px;
  width: fit-content;
 }
 .text-card-picture .title {
    margin-top: 0px;
 }
 .text-card-picture p {
  font-size: 12px;
 }
 .text-card-picture .title i {
    text-align: left;
    transform: translateX(10px);
    min-width: max-content;
 }
 .text-card-picture h2 {
  font-size: 26px;
 }
}

@media screen and (max-width: 375px) {
 .bg-gradient-card {
  background: linear-gradient(
   180deg,
   rgba(0, 0, 0, 0.2) 0%,
   rgba(0, 0, 0, 0.35) 30%,
   rgba(0, 0, 0, 0.9) 90%
  );
 }
}
</style>
